import { useEffect, useState } from 'react';

export type Route =
  | { name: 'home' }
  | { name: 'room'; projectId: string; roomId: string }
  | { name: 'project'; projectId: string }
  | { name: 'projectSettings'; projectId: string }
  | { name: 'settings'; tab: string }
  | { name: 'invite' };

const UUID = '[0-9a-f-]{36}';

export function parse(path: string): Route {
  let m: RegExpMatchArray | null;
  if ((m = path.match(new RegExp(`^/p/(${UUID})/r/(${UUID})$`))))
    return { name: 'room', projectId: m[1]!, roomId: m[2]! };
  if ((m = path.match(new RegExp(`^/p/(${UUID})/settings$`))))
    return { name: 'projectSettings', projectId: m[1]! };
  if ((m = path.match(new RegExp(`^/p/(${UUID})$`)))) return { name: 'project', projectId: m[1]! };
  if ((m = path.match(/^\/settings(?:\/([a-z-]+))?$/)))
    return { name: 'settings', tab: m[1] ?? 'connections' };
  if (path === '/invite') return { name: 'invite' };
  return { name: 'home' };
}

export function navigate(path: string) {
  if (location.pathname !== path) history.pushState(null, '', path);
  window.dispatchEvent(new PopStateEvent('popstate'));
}

export function useRoute(): Route {
  const [route, setRoute] = useState(() => parse(location.pathname));
  useEffect(() => {
    const on = () => setRoute(parse(location.pathname));
    window.addEventListener('popstate', on);
    return () => window.removeEventListener('popstate', on);
  }, []);
  return route;
}
